(function () {
  if (window.__CaInstantOptimized) return;
  window.__CaInstantOptimized = true;

  const isSupported = 'IntersectionObserver' in window;
  const config = {
    prefetchLimit: 10,
    prefetchReset: 30000,
    observerMargin: '300px',
    observerThreshold: 0.1,
    excludedPages: ['/checkout', '/cart', '/account', '/search', '/pages/contact', '/a/sc/amp'],
    fontFallback: 'https://fonts.shopifycdn.com/americana/americana_n4.e48f0c04dfcd15cf0297d6a79006cabda02b0d13.woff2?h1=Y2FyYXVhbmEuY29t&hmac=c3a58fe32e85e800d135ea803a73bd3328ca9db4df3f66ac4c0fcf80fb99c9bf'
  };
  let prefetchCount = 0;

  const preloadLink = (url, as = 'image') => {
    if (!url || document.querySelector(`link[rel="preload"][href="${url}"]`)) return;
    const l = document.createElement('link');
    l.rel = 'preload';
    l.as = as;
    l.href = url;
    l.fetchPriority = 'high';
    l.crossOrigin = 'anonymous';
    document.head.appendChild(l);
  };

  const prefetchLink = (url) => {
    if (prefetchCount >= config.prefetchLimit || document.querySelector(`link[rel="prefetch"][href="${url}"]`) || url.includes('#')) return;
    if (!url.startsWith(window.location.origin) || config.excludedPages.some(p => url.includes(p))) return;
    const l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
    prefetchCount++;
    setTimeout(() => {
      l.parentNode?.removeChild(l);
      prefetchCount = Math.max(0, prefetchCount - 1);
    }, 10000);
  };

  const preloadFonts = () => {
    const style = document.createElement('style');
    style.textContent = `
      .ca-lazy-font,.responsive-image{font-display:swap !important;will-change:transform,opacity;transition:opacity 0.3s ease-in;opacity:0}
      .ca-lazy-font.loaded,.responsive-image.loaded{opacity:1}
      .ca-slide-title,.ca-slide-subtitle{transform:translateY(0)}
      .ca-button{transform:scale(1)}
      .ca-text-container,.responsive-image{min-height:100px}
    `;
    document.head.appendChild(style);

    preloadLink('{{ settings.type_body_font | font_url }}', 'font');
    preloadLink('{{ settings.type_header_font | font_url }}', 'font');
    preloadLink(config.fontFallback, 'font');
    const preconnect = document.createElement('link');
    preconnect.rel = 'preconnect';
    preconnect.href = 'https://fonts.shopifycdn.com';
    preconnect.crossOrigin = 'anonymous';
    document.head.appendChild(preconnect);

    requestIdleCallback(() => {
      document.querySelectorAll('link[href*="fonts.googleapis.com"],link[href*="cdn.shopify.com"]').forEach(l => l.remove());
    });
  };

  const prepareImages = () => {
    let firstImage = true;
    document.querySelectorAll('img[data-ca-lazy],.responsive-image').forEach((img, i) => {
      const rect = img.getBoundingClientRect();
      const inViewport = rect.top < window.innerHeight && rect.bottom > 0;
      if (i === 0 && inViewport && firstImage) {
        img.setAttribute('loading', 'eager');
        img.setAttribute('fetchpriority', 'high');
        firstImage = false;
      } else {
        img.setAttribute('loading', 'lazy');
      }
      if (!img.hasAttribute('width') || !img.hasAttribute('height')) {
        img.setAttribute('width', img.naturalWidth || 1200);
        img.setAttribute('height', img.naturalHeight || 600);
      }
      if (img.dataset.src) img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.sizes) img.sizes = img.dataset.sizes;
      img.classList.add('ca-lazy-loaded', 'loaded');
    });
  };

  const preloadVisibleElements = () => {
    const selectors = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', '.ca-slide-title', '.ca-slide-subtitle', '.ca-button', '.responsive-image', '[data-initial-viewport]'];
    let firstElement = true;
    selectors.forEach(s => {
      document.querySelectorAll(s).forEach(el => {
        if (el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add('ca-lazy-font', 'loaded');
          if (firstElement && (el.tagName === 'IMG' || el.tagName === 'VIDEO')) {
            el.loading = 'eager';
            el.fetchpriority = 'high';
            firstElement = false;
          }
        }
      });
    });

    document.querySelectorAll('img,video').forEach(el => {
      const inViewport = el.getBoundingClientRect().top < window.innerHeight;
      if (inViewport && !el.src && !el.srcset) {
        if (el.dataset.src) preloadLink(el.dataset.src, el.tagName === 'VIDEO' ? 'video' : 'image');
        if (el.dataset.srcset) {
          el.dataset.srcset.split(',').forEach(set => preloadLink(set.trim().split(' ')[0], el.tagName === 'VIDEO' ? 'video' : 'image'));
        }
      }
    });
  };

  const applyLazyLoad = () => {
    const elements = document.querySelectorAll('img[data-ca-lazy],video[data-ca-lazy],.ca-slide-title,.ca-slide-subtitle,.ca-button,.ca-text-container,.responsive-image,[data-ca-lazy]');
    if (isSupported) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            const el = e.target;
            if (el.dataset.src) el.src = el.dataset.src;
            if (el.dataset.srcset) el.srcset = el.dataset.srcset;
            if (el.dataset.sizes) el.sizes = el.dataset.sizes;
            if (el.tagName === 'IMG' || el.tagName === 'VIDEO') {
              el.loading = el.getBoundingClientRect().top < window.innerHeight ? 'eager' : 'lazy';
              el.decoding = 'async';
            }
            if (el.classList.contains('ca-slide-title') || el.classList.contains('ca-slide-subtitle')) {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            }
            if (el.classList.contains('ca-button')) {
              el.style.opacity = '1';
              el.style.transform = 'scale(1)';
            }
            if (el.classList.contains('ca-text-container') || el.classList.contains('responsive-image')) {
              el.style.opacity = '1';
            }
            el.classList.add('ca-lazy-loaded', 'loaded');
            obs.unobserve(el);
          }
        });
      }, { rootMargin: config.observerMargin, threshold: config.observerThreshold });
      elements.forEach(el => observer.observe(el));
    } else {
      elements.forEach(el => {
        if (el.dataset.src) el.src = el.dataset.src;
        if (el.dataset.srcset) el.srcset = el.dataset.srcset;
        if (el.dataset.sizes) el.sizes = el.dataset.sizes;
        if (el.tagName === 'IMG' || el.tagName === 'VIDEO') {
          el.loading = 'lazy';
          el.decoding = 'async';
        }
        el.classList.add('ca-lazy-loaded', 'loaded');
      });
    }
  };

  const preloadOnHover = () => {
    document.querySelectorAll('a[href]').forEach(a => {
      a.addEventListener('pointerenter', () => {
        const url = a.href;
        if (url.endsWith('.jpg') || url.endsWith('.webp')) preloadLink(url);
        else prefetchLink(url);
      }, { passive: true, once: true });
    });
  };

  const preloadNextScrollElements = () => {
    requestIdleCallback(() => {
      document.querySelectorAll('img[data-ca-lazy],video[data-ca-lazy]').forEach((el, i) => {
        if (i < 5 && !el.src && !el.srcset) {
          if (el.dataset.src) preloadLink(el.dataset.src, el.tagName === 'VIDEO' ? 'video' : 'image');
          if (el.dataset.srcset) {
            el.dataset.srcset.split(',').forEach(set => preloadLink(set.trim().split(' ')[0], el.tagName === 'VIDEO' ? 'video' : 'image'));
          }
        }
      });
    });
  };

  window.addEventListener('DOMContentLoaded', () => {
    preloadFonts();
    prepareImages();
    preloadVisibleElements();
    applyLazyLoad();
    preloadOnHover();
    preloadNextScrollElements();
  });

  setInterval(() => { prefetchCount = 0; }, config.prefetchReset);
})();